module.exports = __webpack_public_path__ + "static/media/photo174.9c007494.jpg";